export default "__VITE_ASSET__f08f206c__"